import { useState } from "react";
import { styles, UserContainer, } from "./components/PanelComponents.jsx";
import Card from "../components/Card/Card";
import CardHeader from "../components/Card/CardHeader";
import CardBody from "../components/Card/CardBody.js";
import { makeStyles } from "@mui/styles";

import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "../components/generics/tabPanels";
import BannerImagesTab from "./components/BannerImagesTab.jsx";
import HomeProductsTab from "./components/HomeProductsTab.jsx";


const useStyles = makeStyles(styles);

function Panel() {
    const classes = useStyles();



    //tabs
    const [value, setValue] = useState(1);


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <UserContainer>
            <Card>
                <CardHeader color="success">
                    <h2 className={classes.cardTitleWhite}>
                        Panel de Control
                    </h2>
                    <p className={classes.cardCategoryWhite}>
                        Panel de control de la aplicación Mobile
                    </p>
                </CardHeader>
                <CardBody>
                    <Paper square>
                        <Tabs
                            value={value}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={handleChange}
                        >
                            <Tab label="Carrousel" />
                            <Tab label="Home" />
                        </Tabs>
                    </Paper>
                    <>
                        <TabPanel value={value} index={0}>
                            <BannerImagesTab />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <HomeProductsTab />
                        </TabPanel>
                    </>
                </CardBody>

            </Card>

        </UserContainer>
    );
}

export default Panel;
